import React from 'react';
import { Section, SectionHeading, Reveal } from '../shared/Section';
const modules = [{
  num: '01',
  title: 'Módulo Lumbar: Libera tu Espalda Baja',
  text: 'Rutinas específicas para descomprimir la zona lumbar, reducir tensión muscular y recuperar una postura sana. Incluye ejercicios para el día a día y para momentos de dolor agudo.'
}, {
  num: '02',
  title: 'Módulo Cervical: Cuello y Hombros Libres',
  text: 'Secuencias suaves para liberar la tensión del cuello y trapecios. Ideal si pasás horas frente a una pantalla. Vas a notar la diferencia desde la primera sesión.'
}, {
  num: '03',
  title: 'Módulo Rodilla: Rodillas Fuertes y Estables',
  text: 'Ejercicios de movilidad para cadera, tobillo y cuádriceps que reducen la carga sobre la rodilla. Seguras y efectivas para cualquier nivel de actividad física.'
}, {
  num: '04',
  title: 'Módulo Estiramientos: Rutinas Diarias Completas',
  text: 'Secuencias de 10 a 20 minutos para integrar en tu rutina de mañana o noche. Ganá flexibilidad, prevenís lesiones y mantenés el cuerpo activo.'
}, {
  num: '05',
  title: 'Módulo Cadera y Tobillo: Movete con Más Libertad',
  text: 'Movimientos guiados para recuperar movilidad en caderas y tobillos, mejorar tu estabilidad y descargar las articulaciones en cada paso.'
}, {
  num: '06',
  title: 'Módulo Progreso: Tu Plan de Movilidad Sostenible',
  text: 'Una guía simple para organizar tus prácticas, medir tus avances y convertir la movilidad en un hábito que se adapta a tu vida.'
}];
export function Modules() {
  return <Section id="modulos" bg="bg-forest-700" data-id="element-132" data-mp="16gq6eonrh84s">
      <Reveal data-id="element-133" data-mp="16j2wjp3oaosx">
        <div className="max-w-2xl" data-id="element-134" data-mp="1bg33e28cjvl3">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-clay-400" data-id="element-135" data-mp="1bf1fuya59gmh">
            El programa
          </p>
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl md:text-[2.75rem]" data-id="element-136" data-mp="1fjhjeswacbyj">
            6 Módulos de puro conocimiento práctico
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/60 sm:text-lg" data-id="element-137" data-mp="3gk5n52wj8uxv">
            Todo lo que necesitás para atacar el dolor en sus zonas clave, organizado de forma
            clara y progresiva.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-138" data-mp="3ligxrfunj9h5">
        {modules.map((m, i) => <Reveal key={m.num} index={i} data-id="element-139" data-mp="41zex3kahm31" data-mpi={i}>
            <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-forest-800/60 p-7 transition-colors duration-200 hover:border-clay-400/40" data-id="element-140" data-mp="40xpfu2j0x1s">
              <span className="font-display text-4xl font-semibold text-clay-400" data-id="element-141" data-mp="d3p2fyb1w0vj">{m.num}</span>
              <h3 className="mt-3 font-display text-xl font-semibold text-white" data-id="element-142" data-mp="83kp2h5fvm9j">{m.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/65" data-id="element-143" data-mp="2eu0k7kiq9vti">{m.text}</p>
            </div>
          </Reveal>)}
      </div>
    </Section>;
}